import { CtaCard } from "@jesus-central-church/ui";
import { SbCtaCard } from "@storyblok/types/287435740670216/storyblok-components";
import { linkResolver } from "../../lib/storyblok";

export function CtaCardComponent({
  blok,
}: {
  blok: SbCtaCard;
  pageData: { locale: string };
}) {
  const link =
    blok.buttonLink === null || blok.buttonLink?.cached_url === ""
      ? undefined
      : linkResolver(blok.buttonLink);

  return (
    <CtaCard
      title={blok.title}
      subtitle={blok.subtitle}
      time={blok.time}
      day={blok.day}
      buttonText={blok.buttonText}
      buttonHref={link}
    />
  );
}
